import { REVIEWEE_FILTER_QUERY_KEYS } from "@domains/reviews/client/components/reviewee-filters/revieweeFilterQueryKeys.ts";

export const ANALYTICS_FILTER_QUERY_KEYS = [...REVIEWEE_FILTER_QUERY_KEYS, "reviewCycleIds", "reviewHistoryFilter", "from", "to"] as const;
